import { render, staticRenderFns } from "./SalesAggregation.vue?vue&type=template&id=06ecb4d3&"
import script from "./SalesAggregation.vue?vue&type=script&lang=js&"
export * from "./SalesAggregation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports